module.exports = __webpack_public_path__ + "catalog/items/firesafety/Fire-Door/Fire-Door.svg";